import React, { FC, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { Input, Submit } from "../../BookingLegacy/FormElements";
import { stepOneValidator } from "../MyAppointmentValidation";

import { FieldErrorPosition } from "../../BookingLegacy/Helpers/interfaces";
import { FieldStatus } from "../../BookingLegacy/Helpers/FieldStatus";
import { LoadingAnimation } from "../../LoadingAnimation/LoadingAnimation";
import { useLabels } from "../../BookingLegacy/Hooks/useLabels";
import { Errors } from "../Errors";
import { StepOneParams } from "../../../Pages/MyAppointment/Steps/StepOneParams.csharp";

interface StepOneProps extends StepOneParams {
  sendCancellationRequest: (smsCode: string, personalNumber: string) => void;
  isDataLoading: boolean;
  apiErrors: string[];
  addResetCallback?: (callback: () => void) => void;
}

type DetailsFirstStepForm = {
  personalIdNumber: string;
  smsCode: string;
};

export const LoginStep: FC<StepOneProps> = ({
  loginButtonText,
  smsCodeLabel,
  ssnLabel,
  content,
  sendCancellationRequest,
  isDataLoading,
  apiErrors,
  addResetCallback,
}) => {
  const { bookingLabels } = useLabels();
  const errorLabels = bookingLabels?.bookingErrors;

  const {
    handleSubmit,
    formState: { errors },
    register,
    getValues,
    reset,
  } = useForm<DetailsFirstStepForm>({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(stepOneValidator(errorLabels)),
  });

  useEffect(() => {
    if (addResetCallback) addResetCallback(reset);
  }, []);

  const stepOneSubmit = ({
    smsCode,
    personalIdNumber,
  }: DetailsFirstStepForm) => {
    sendCancellationRequest(smsCode, personalIdNumber);
  };

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: content }} />
      <Errors errors={apiErrors} />
      <form
        className="row"
        onSubmit={handleSubmit(stepOneSubmit)}
        autoComplete="off"
      >
        <div className="col-18 col-sm-12 col-md-12 col-lg-9">
          <Input
            label={ssnLabel}
            type="number"
            name="personalIdNumber"
            error={errors["personalIdNumber"]}
            autocomplete="off"
            errorPosition={FieldErrorPosition.bottom}
            register={register}
            getValues={getValues}
            inputmode="numeric"
            pattern="\d{11}"
            className="my-appointment-input"
          />
        </div>
        <div className="col-18 col-sm-12 col-md-12 col-lg-9">
          <Input
            label={smsCodeLabel}
            name="smsCode"
            type="password"
            autocomplete="off"
            error={errors["smsCode"]}
            errorPosition={FieldErrorPosition.bottom}
            register={register}
            getValues={getValues}
            className="my-appointment-input"
          />
        </div>
        <div className="input__wait__submit mb-1">
          <Submit
            status={isDataLoading ? FieldStatus.disabled : FieldStatus.active}
          >
            {isDataLoading ? (
              <LoadingAnimation text={"Behandler"} />
            ) : (
              loginButtonText
            )}
          </Submit>
        </div>
      </form>
    </div>
  );
};
